import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black, white, gray } from 'constants/colors';
import SpeedDatingImage from 'assets/images/narratives/speed_dating.jpg';

export const CallForImpactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  vertical-align: top;
  margin: 0 1rem 1rem 0;
  background-color: #fff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 2rem;
  width: 30rem;
  background-size: cover;
  background-position: 50%;
  height: 37rem;
  font-size: 1.2rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  .opacity {
    position: absolute;
    z-index: 5;
    background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .header {
    z-index: 10;
    height: 20%;
    display: flex;

    .content {
      width: 100%;
      height: 70%;
      margin: 1.5rem 1rem;
      display: flex;
    }

    .name {
      overflow: hidden;
      font-family: ${RalewayFont.semiBoldFamily};
      color: ${black};
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 2rem;
      margin-left: 0.5rem;
      height: 80%;
    }

    .date {
      font-family: ${RalewayFont.regularFamily};
      color: ${white};
      margin: 0.5rem 0;
      font-size: 1.3rem;
    }

    .countdown {
      font-size: 1.8rem;
    }
  }

  .photo {
    height: 50%;
    width: 100%,
  }

  .desc_call {
    line-height: 1.8rem;
    margin-top: 2rem;
    height: 11rem;
    overflow: auto;
  }

  .details {
    color: #2680EB;
    margin-bottom: 1rem;
    white-space: normal;
    font-family: ${RalewayFont.semiBoldFamily};
    font-size: 1.3rem;
    line-height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &.disabled {
      color: ${gray};
    }
  }

  .banner {
    background-position: 50% 50%;
    height: 13rem;
    background-size: cover;
  }

  .banner_speed_dating {
    height: 13rem;
    background-color: #eee;
    text-align: center;
    padding-top: 1.5rem;
  }

  .footer {
    padding: 1.5rem 1rem 1rem;
    width: 100%;
    z-index: 10;
    height: 40%;

    .form_buttons {
      text-align: center;
      .claim {
        width: 45%;
      }
    }

    .name {
      margin-bottom: 1rem;
      white-space: normal;
      font-family: ${RalewayFont.semiBoldFamily};
      color: ${white};
      font-size: 1.6rem;
      line-height: 2rem;
    }

    .content_detail {
      display: flex;
      justify-content: space-between;
    }

    .options {
      margin-top: 2rem;
      font-size: 1.2rem;
      display: none;
      .status {
        color: #FFA200;
        &.disabled {
          color: ${gray};
        }
      }
    }
  }
  .footer_bottom {

    .plan_speed_dating {
      justify-content: center;
      display: flex;
      margin: 1rem 0;

      button {
        border: none;
        border-radius: 2rem;
        padding: 1rem 1.5rem;
        background-color: #8AD923;
        font-family: ${RalewayFont.regularFamily};
        font-size: 1.3rem;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
      }
    }

    .plan_meeting {
      justify-content: center;
      display: flex;
      margin: 1rem 0;

      button {
        border: none;
        border-radius: 2rem;
        padding: 1rem 1.5rem;
        background-color: #FFA304;
        font-family: ${RalewayFont.regularFamily};
        font-size: 1.3rem;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
      }
    }
  }
`;

export const HeaderCard = styled.div`
  z-index: 10;
  height: 30%;
  background: ${props => props.img};
  background-size: cover;
  display: flex;
  flex-direction: column;
  color: white;

  .opacity {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    z-index: -1;
    background-color: rgba(0,0,0,0.2);
    border: ${props => (props.reStart ? ' 0.5rem solid #2680EB' : '')};
    border-radius: ${props => (props.reStart ? '2rem 2rem 0rem 0rem' : '')};
  }

  .content {
    width: 88%;
    height: 70%;
    margin-left: 2rem;
    margin-top: 1rem;
    color: white;
    display: flex;
  }

  .switch {
    margin-left: 2rem;
    margin-bottom: 1rem;
  }

  .name {
    overflow: hidden;
    font-family: ${RalewayFont.regularFamily};
    color: ${white};
    font-size: 1.4rem;
    line-height: 2rem;
    margin-left: 0.5rem;
  }

  .date {
    font-family: ${RalewayFont.regularFamily};
    color: ${white};
    margin: 0.5rem 0;
    font-size: 1.3rem;
  }

  .countdown {
    font-size: 1.8rem;
  }
  }
`;

export const Name = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;

export const Description = styled.div`
  color: #fff;
  font-size: 13px;
  margin-top: 2px;
  line-height: 18px;
`;

export const Seconds = styled.div`
  color: #000;
  background-color: #fff;
  margin-left: 5px;
  display: inline-block;
`;

export const SpeedDatingBubble = styled.div`
  cursor: pointer;
  margin: 0 22px 20px;
  padding: 20px;
  width: calc(100% - 44px);
  border-radius: 3px;
  box-shadow: 0px 3px 5px 0px rgba(0,0,0, 0.3);
  background-image: url(${SpeedDatingImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  position: relative;

  .opacity_layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1;
    display: block;
  }

  .speed_user_content {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 100px);
    margin-left: 10px;
    position: relative;
    z-index: 2;
  }

  .avatar_bubble {
    position: relative;
    z-index: 2;
  }

  .position {
    font-weight: 600 !important;
  }

  button {
    margin: 10px auto 0;
    transform: translateX(-40px);
    width: 200px;
  }
`;

export const Details = styled.div`
  padding: 1rem;
  .description {
    font-size: 1.2rem;
    color: #30423E;
    line-height: 1.6rem;
  }

  .tags {
    white-space: nowrap;
    overflow: auto;
    margin: 1rem 0;
  }

  .title_section {
    font-size: 1.4rem;
    color: ${black};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Cards/Call4ImpactCard/components/styles.js